<template>
  <div class="cites-content">
    <div class="cite-top">
      <img src="@/assets/images/cites/cite2.png" alt="" />
    </div>
    <div class="cites">
      <div class="left">
        <img src="@/assets/images/cites/cite1.png" alt="" />
      </div>
      <div class="right">
        <div class="top">
          15 Szenen.<br />
          OHNE SCHNITT.
        </div>
        <span>Dietrich Brüggemann:</span> „NÖ ist ein Film über die Liebe, über
        unsere Jagd nach ihr und unser Unvermögen, sie zu leben, wenn sie mal da
        ist. Ein Film über die verstreichende Zeit und über die Generation um
        die dreißig, die Vieles hat, Vieles versucht und oft still scheitert. Es
        ist aber auch ein Film über das, was das Kino besonders gut kann:
        Seelenzustände ausleuchten, die jenseits des Sichtbaren liegen, die aber
        nicht weniger real und ausschlaggebend für unseren Lebensweg sind.”
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.cites-content {
  .cite-top {
    text-align: center;
    padding-block: 2em;
  }
  .cites {
    max-width: 1720px;
    display: flex;
    color: black;
    font-size: 1.5rem;
    margin-inline: auto;
    padding-bottom: 2em;
    span {
      font-weight: 700;
    }
    .left {
      padding-right: 1.5em;
    }
    .right {
      .top {
        font-family: 'Daft Brush';
        font-size: 4rem;
        line-height: 4.5rem;
        margin-block: 0.25em;
      }
    }
    @media (max-width: 1740px) {
      flex-direction: column;
      align-items: center;
      padding-inline: 2em;
      .left {
        margin-bottom: 1em;
      }
    }
    @media (max-width: 1100px) {
      .left {
        img {
          max-width: 800px;
        }
      }
    }
  }
}
</style>
